import React from 'react';
import './Referral.css';
import SEO from '../components/SEO';
import { withAttribution } from '../lib/attribution';

const Referral: React.FC = () => {
  return (
    <div className="referral-page">
      <SEO
        title="Member Referral Program | Commissary Connect"
        description="Refer a food entrepreneur to Commissary Connect's shared commercial kitchens and you both earn rewards. How the member referral program works."
      />
      <div className="container">
        <div className="referral-hero">
          <h1>Member Referral Program</h1>
          <h2 className="referral-tagline">Grow Your Network. Grow Your Rewards.</h2>
          <p className="referral-subtitle">
            When you refer a food entrepreneur to Commissary Connect, you both win. 
            It's our way of saying thank you for helping fellow businesses thrive.
          </p>
        </div>

        <div className="how-it-works">
          <h2>How It Works</h2>
          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <h3>REFER</h3>
              <p>
                Know someone ready to take their food business to the next level? 
                Simply have them mention your business name when they apply online 
                or during their kitchen tour.
              </p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>SUCCEED TOGETHER</h3>
              <p>
                We'll guide your referral through our streamlined application process. 
                When they sign a membership agreement, you both qualify for rewards.
              </p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>GET REWARDED</h3>
              <div className="rewards-list">
                <p><strong>Your referral gets 10% off</strong> their membership</p>
                <p><strong>You get an equal dollar credit</strong> applied to your account</p>
                <p><strong>No limit</strong> on how many businesses you can refer</p>
              </div>
            </div>
          </div>
        </div>


        <div className="why-refer">
          <h2>Why Refer to Commissary Connect?</h2>
          <p>
            You know the value of our professional kitchens, supportive community, 
            and business growth resources. Share that success and earn meaningful 
            rewards for helping fellow entrepreneurs thrive.
          </p>
          <div className="benefits-grid">
            <div className="benefit">
              <span className="check">✓</span>
              <p>Help fellow food entrepreneurs succeed</p>
            </div>
            <div className="benefit">
              <span className="check">✓</span>
              <p>Strengthen our food community</p>
            </div>
            <div className="benefit">
              <span className="check">✓</span>
              <p>Earn unlimited referral credits</p>
            </div>
            <div className="benefit">
              <span className="check">✓</span>
              <p>Build valuable business connections</p>
            </div>
          </div>
        </div>

        <div className="referral-cta">
          <h2>Ready to Start Referring?</h2>
          <p>Share your success story and help grow our community of food entrepreneurs.</p>
          <div className="cta-buttons">
            <a 
              href={withAttribution('https://v2.commissaryconnect.com/forms/referral-form')}
              className="btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Submit a Referral
            </a>
          </div>
        </div>

        <div className="terms-section">
          <h3>Terms & Conditions</h3>
          <ul>
            <li>Referral must be a new customer who has not previously applied or toured</li>
            <li>Referral must mention your business name during application</li>
            <li>Credits applied within 30 days of referral's move-in date</li>
            <li>Referral rewards based on membership agreement terms</li>
            <li>No limit on number of referrals</li>
            <li>Credits can accumulate and roll over to future months</li>
            <li>Program terms subject to change with 30 days notice</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Referral;